import { render, staticRenderFns } from "./addMerchant.vue?vue&type=template&id=2c043aef"
import script from "./addMerchant.vue?vue&type=script&lang=js"
export * from "./addMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports